<template>
  <v-card elevation="0" tile outlined class="pa-0 d-flex flex-column">
    <!-- :loading="loading" -->
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <div v-if="data.images && data.images.length > 0">
      <CarouselImages :items="data.images"></CarouselImages>
    </div>

    <v-card-title>{{ data.nombre }}</v-card-title>

    <v-card-text>
      <div class="subtitle-1">
        {{ data.descripcion }}
      </div>

      <div>{{ data.tecnologias }}</div>
    </v-card-text>

    <v-spacer></v-spacer>
    <v-divider></v-divider>

    <v-card-actions class="d-flex justify-end">
      <v-btn
        class="caption"
        small
        text
        color="primary"
        @click="to('proyecto', { id: data.id })"
      >
        editar
      </v-btn>
      <v-btn
        v-if="!disableActions"
        class="caption"
        small
        text
        color="error"
        @click="$emit('deleteProject', data.id)"
      >
        {{
          isProjectDeletionPending ? 'Eliminacion en progreso...' : 'eliminar'
        }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CarouselImages from '@/components/normal/CarouselImages.vue'

export default {
  components: {
    CarouselImages
  },
  props: {
    data: Object,
    index: Number,
    isProjectDeletionPending: Boolean,
    disableActions: Boolean
  },
  computed: {
    categoriaText() {
      return this.data.categoria
    }
  },
  methods: {
    to(name, params) {
      // console.log('to -> name', name)
      this.$router.push({ name, params })
    }
  }
}
</script>

<style lang="scss" scoped></style>
